import script from "./chart9.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart9.vue?vue&type=script&lang=ts&setup=true"

import "./chart9.vue?vue&type=style&index=0&id=3832433d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3832433d"]])

export default __exports__